(() => {
  'use strict';

  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  let hoveredPreview = null;

  function clearPreview() {
    if (hoveredPreview) hoveredPreview.classList.remove('is-previewing');
    hoveredPreview = null;
  }

  document.addEventListener('pointermove', (event) => {
    if (!desktopHover.matches || event.pointerType !== 'mouse') {
      clearPreview();
      return;
    }

    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const card = target?.closest('.product-card-wrapper');
    const preview = card?.querySelector('.product-card-media-preview');
    const bounds = preview?.getBoundingClientRect();
    const overImage = bounds && event.clientX >= bounds.left && event.clientX <= bounds.right &&
      event.clientY >= bounds.top && event.clientY <= bounds.bottom;

    if (!overImage) {
      clearPreview();
      return;
    }

    if (hoveredPreview && hoveredPreview !== preview) clearPreview();
    hoveredPreview = preview;
    preview.style.setProperty('--product-preview-x', `${Math.min(100, Math.max(0, ((event.clientX - bounds.left) / bounds.width) * 100))}%`);
    preview.style.setProperty('--product-preview-y', `${Math.min(100, Math.max(0, ((event.clientY - bounds.top) / bounds.height) * 100))}%`);
    preview.classList.add('is-previewing');
  });

  document.addEventListener('pointerout', (event) => {
    if (!event.relatedTarget) clearPreview();
  });
  window.addEventListener('blur', clearPreview);
})();
